import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { c } from "../../../theme/colorUtils";

export const DeviceImageWrap = styled(Box)(() => ({
  width: 80,
  height: 80,
  borderRadius: "50%",
  background: "#F0F1F5",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  overflow: "hidden",
  "& img": {
    width: "50%",
    padding: 8,
    objectFit: "contain",
  },
}));

export const DeviceInfoSection = styled(Stack)(() => ({
  width: "100%",
  gap: 24,
  alignItems: "stretch",
}));

export const DeviceInfoCard = styled(Box)(() => ({
  width: "100%",
  background: c.bg,
}));

export const ProfileSection = styled(Stack)(() => ({
  width: "100%",
  gap: 8,
}));

export const SectionTitle = styled(Box)(() => ({
  fontSize: "0.875rem",
  fontWeight: 700,
  color: c.text02,
}));

export const InfoRow = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 0 4px",
}));

export const DetailTitle = styled(Typography)(() => ({
  fontSize: "0.875rem",
  color: c.text02,
}));

/** 기기 정보 행: 라벨(펜 이름·시리얼) 고정 너비 */
export const DeviceInfoLabel = styled(Typography)(() => ({
  fontSize: "0.875rem",
  color: c.text02,
  width: 65,
  minWidth: 65,
  maxWidth: 65,
  flexShrink: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export const PenNameEditTrigger = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  gap: 4,
  cursor: "pointer",
}));

export const ProfileCard = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  cursor: "pointer",
}));

export const MemorySection = styled(Box)(() => ({
  padding: 16,
  background: c.bg,
  borderRadius: 16,
  border: `1px solid ${c.grayLight}`,
  display: "flex",
  flexDirection: "column",
  gap: 16,
}));

export const MemoryRow = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 16,
  borderRadius: 8,
  background: c.bg02,
}));

export const SettingsRestartNote = styled(Typography)(() => ({
  fontSize: "0.75rem",
  color: c.text02,
  lineHeight: 1.5,
  textAlign: "center",
}));

export const EmptyProfileCard = styled(Box)(() => ({
  padding: 20,
  background: c.bg,
  borderRadius: 24,
  border: `1px solid ${c.grayLight}`,
}));

export const EmptyProfileText = styled(Typography)(() => ({
  color: c.text02,
  textAlign: "center",
  fontSize: "1rem",
  fontWeight: 500,
  marginBottom: 16,
}));

export const ProfileSetupButton = styled(Box)(() => ({
  width: "100%",
  padding: "14px 16px",
  borderRadius: 12,
  border: `1px dashed ${c.grayHard}`,
  textAlign: "center",
  color: c.text01,
  fontSize: "1rem",
  fontWeight: 700,
  cursor: "pointer",
  boxSizing: "border-box",
}));

export const DeviceDetailBody = styled(Stack)(() => ({
  flex: 1,
  minHeight: 0,
  width: "100%",
}));

export const DeviceDetailScrollArea = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
  padding: "32px 16px 16px",
  boxSizing: "border-box",
}));

export const DeviceDetailFooter = styled(Box)(() => ({
  flexShrink: 0,
  width: "100%",
  padding: 16,
  paddingBottom: "max(16px, env(safe-area-inset-bottom, 0px))",
  background: c.bg,
  borderTop: `1px solid ${c.grayLight}`,
  boxSizing: "border-box",
}));

export const DisconnectButton = styled(Box)(() => ({
  width: "100%",
  padding: 16,
  background: c.bg,
  border: `1px solid ${c.grayHard}`,
  color: c.error,
  borderRadius: 8,
  textAlign: "center",
  cursor: "pointer",
  boxSizing: "border-box",
  "&:hover": {
    background: c.grayLightest,
  },
}));

